import type { RouteHandle } from 'src/root';
import type { LoaderFunctionArgs } from 'react-router';
import type { ServerRendered } from 'src/server/catalog.server';

import { useLoaderData } from 'react-router';

import { isWideRequest } from 'src/utils/device';

import { DealerHome } from 'src/screens/DealerHome';
import { loadCatalog } from 'src/server/catalog.server';

import { ServerAnswers } from 'src/components/ServerAnswers';

export const handle: RouteHandle = { serverRendered: true };

/**
 * A dealer's page — the target of the cabinet's QR code — asked of the api by the server: the
 * dealer's cars for sale, or with `?vertical=rent` the same dealer's rentals.
 */
export async function loader({ request, params }: LoaderFunctionArgs) {
  return loadCatalog({
    request,
    vertical: new URL(request.url).searchParams.get('vertical') === 'rent' ? 'rent' : 'buy',
    dealerId: params.sellerId ?? '',
    wide: isWideRequest(request),
  });
}

/** Every later visit is the browser's own: the screen asks the api itself, as it always did. */
export const clientLoader = () => null;

export default function DealerRoute() {
  const rendered = useLoaderData() as ServerRendered | null;

  return (
    <ServerAnswers rendered={rendered}>
      <DealerHome />
    </ServerAnswers>
  );
}
